export default __webpack_public_path__ + "static/media/chosen-first-card.0752d1a1.svg";